import React, { useState, useRef, useEffect } from "react";
import { WIDTH, HEIGHT, DPI } from "../parametres";

function Input({ updateMur }) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = WIDTH * 300 * DPI;
    canvas.height = HEIGHT * 300 * DPI;

    const [visibility, setVisibility] = useState({
        texte: true,
        image: true,
    });
    const [range, setRange] = useState({
        fontSize: 58,
        position: 90,
    });
    const [text, setText] = useState("");
    const [srcImage, setSrcImage] = useState(canvas.toDataURL("image/png"));
    const [imgLoaded, setImgLoaded] = useState(undefined);

    function clearImage() {
        ctx.fillStyle = "white";
        ctx.strokeStyle = "black";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.strokeRect(0, 0, canvas.width, canvas.height);
        setImgLoaded(undefined);
        setText("");
    }

    function refreshImage() {
        ctx.fillStyle = "white";
        ctx.strokeStyle = "black";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.strokeRect(0, 0, canvas.width, canvas.height);

        if (visibility.image) {
            if (imgLoaded) {
                const ratio = imgLoaded.width / imgLoaded.height;
                const wImage =
                    ratio > 1 ? 0.8 * canvas.width : 0.8 * canvas.width * ratio;
                const hImage =
                    ratio > 1
                        ? (0.8 * canvas.width) / ratio
                        : 0.8 * canvas.width;

                ctx.drawImage(
                    imgLoaded,
                    (canvas.width - wImage) / 2,
                    0.1 * canvas.width,
                    wImage,
                    hImage
                );
            }
        }
        if (visibility.texte) {
            ctx.font = range.fontSize + "px Arial";
            ctx.fillStyle = "#ffffff99";
            ctx.fillRect(
                0.1 * canvas.width,
                (canvas.height * range.position) / 100 - range.fontSize / 2,
                0.8 * canvas.width,
                range.fontSize
            );
            ctx.fillStyle = "black";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.fillText(
                text,
                canvas.width / 2,
                (canvas.height * range.position) / 100,
                0.8 * canvas.width
            );
        }
        setSrcImage(canvas.toDataURL("image/png"));
    }
    function handleVisibilityChange(e) {
        setVisibility({
            ...visibility,
            [e.target.name]: e.target.checked,
        });
    }
    function handleRangeChange(e) {
        e.preventDefault();
        setRange({
            ...range,
            [e.target.name]: e.target.value,
        });
    }
    function handleTextChange(e) {
        setText(e.target.value);
    }
    function handleClick(e) {
        e.preventDefault();
        document.getElementById("inputFile").click();
    }
    function handleFileChange(e) {
        e.preventDefault();
        const files = e.target.files;

        if (files && files[0].type.match("image/*")) {
            const reader = new FileReader();

            reader.onload = function (event) {
                const img = new Image();
                img.src = reader.result;
                img.onload = function () {
                    setImgLoaded(img);
                };
            };
            reader.readAsDataURL(files[0]);
        }
    }
    useEffect(() => {
        refreshImage();
    });
    useEffect(() => {
        clearImage();
    }, [updateMur]);

    return (
        <div className="card mb-3 mx-auto">
            <div className="row g-0">
                <div className="col-md-4 text-center">
                    <img
                        src={srcImage}
                        className="img-fluid rounded-start"
                        alt="Image à afficher sur la carte"
                    />
                </div>

                <div className="col-md-8">
                    <div className="card-body my-auto">
                        <div className="card-text">
                            <div className="card mb-3">
                                <div className="card-header bg-info">
                                    <label className="form-label">
                                        <input
                                            className="me-2"
                                            name="texte"
                                            type="checkbox"
                                            checked={visibility.texte}
                                            onChange={handleVisibilityChange}
                                        />
                                        Afficher un texte
                                    </label>
                                </div>
                                <div className="card-body">
                                    <input
                                        className="form-control mb-3"
                                        type="text"
                                        placeholder="Texte à afficher"
                                        value={text}
                                        onChange={handleTextChange}
                                    />
                                    <div className="row">
                                        <div className="col">
                                            <label className="form-label">
                                                Taille des caractères
                                            </label>
                                            <input
                                                className="form-range"
                                                type="range"
                                                name="fontSize"
                                                id=""
                                                min="30"
                                                max="300"
                                                value={range.fontSize}
                                                onChange={handleRangeChange}
                                            />
                                        </div>
                                        <div className="col">
                                            <label className="form-label">
                                                Position du texte
                                            </label>
                                            <input
                                                className="form-range"
                                                type="range"
                                                name="position"
                                                id=""
                                                min="0"
                                                max="100"
                                                value={range.position}
                                                onChange={handleRangeChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card mb-3">
                                <div className="card-header bg-info">
                                    <label className="form-label">
                                        <input
                                            className="me-2"
                                            name="image"
                                            type="checkbox"
                                            checked={visibility.image}
                                            onChange={handleVisibilityChange}
                                        />
                                        Insérer une image
                                    </label>
                                </div>
                                <div className="card-body text-center">
                                    <input
                                        className="d-none"
                                        type="file"
                                        name="file"
                                        id="inputFile"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                    />
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleClick}
                                    >
                                        Uploader une image
                                    </button>
                                </div>
                            </div>
                            <div className="mb-4 text-center bg-danger">
                                <div className="d-grid gap-2">
                                    <button
                                        className="btn btn-success btn-block"
                                        onClick={(_) => {
                                            updateMur(canvas);
                                        }}
                                    >
                                        Valider la carte
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Input;
